module.exports = __webpack_public_path__ + "media/images/logo/client-list-3d75ae5928c357d8d203d3a159427aac.svg";